import { render, staticRenderFns } from "./detail_other.vue?vue&type=template&id=08020cca&"
import script from "./detail_other.vue?vue&type=script&lang=ts&"
export * from "./detail_other.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports